import BillsPage from "../modules/billing/pages/BillsPage";
import PaymentPage from "../modules/billing/pages/PaymentPage";
import PaymentCardsPage from "../modules/payments/pages/PaymentCardsPage";
import StatementOfAccountPage from "../modules/statement-of-account/pages/StatementOfAccountPage";
import FormsPage from "../modules/client-forms/pages/FormsPage";
import ConsentFormPage from "../modules/client-forms/pages/ConsentFormPage";
import SessionResourcesPage from "../modules/session-resources/components/SessionResources/SessionResources";

interface Route {
    path: string;
    component: () => React.ReactElement;
}

const routes: Route[] = [
    {
        path: "/billing",
        component: BillsPage,
    },
    { path: "/payment-page", component: PaymentPage },
    { path: "/payment-cards", component: PaymentCardsPage },
    { path: "/statement-of-account", component: StatementOfAccountPage },
    { path: "/session-resources", component: SessionResourcesPage },
    { path: "/forms", component: FormsPage },
    {
        path: "/forms/consent/:bookingId",
        component: ConsentFormPage,
    },
];

export default routes;
